import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'
import { 
  ProductsCarouselSales, 
  ProductsPopularCarousel,
  ProductsPreviouslyOrderedCarousel
} from '@features/products-carousel'

import NewProductsBlock from './NewProductsBlock'
import PersonalizedProductsBlock from './PersonalizedProductsBlock'
import ProductCategoryBlock from './ProductCategoryBlock'
import ProductFilterBlock from './ProductFilterBlock'
import ProductGroupBlock from './ProductGroupBlock'


const productBlockComponents: Record<string, React.FC<BlockProps>> = {
  group: (props) => <ProductGroupBlock {...props} />,
  category: (props) => <ProductCategoryBlock {...props} />,
  popular: () => <ProductsPopularCarousel />,
  sale: () => <ProductsCarouselSales />,
  previouslyOrdered: () => <ProductsPreviouslyOrderedCarousel />,
  new: (props) => <NewProductsBlock {...props} />,
  filter: (props) => <ProductFilterBlock {...props} />,
  personalized: (props) => <PersonalizedProductsBlock {...props} />,
}

export default function ProductsBlock ({
  block,
  payload,
  shopId
}: BlockProps) {

  const BlockComponent = block.subtype ? productBlockComponents[block.subtype] : null

  if (!BlockComponent) {
    return null
  }

  return (
    <div className={styles.root__carousel}>
      <BlockComponent
        block={block}
        payload={payload}
        shopId={shopId}
      />
    </div>
  )
}